<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"showGateways":true,"defaultGateway":"","gatewaysSettings":[{"gateway":"torobpay","installment":true,"percent":0,"prepaymentPercent":0,"enabled":true},{"gateway":"digipay","installment":true,"percent":0,"prepaymentPercent":0,"enabled":true}],"storeLastName":false,"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationProduct","showDescription":true,"showFeatures":true,"showComments":true,"showVariationTable":true,"variationTableTitle":"\u062c\u062f\u0648\u0644 \u0645\u062a\u063a\u06cc\u0631\u0647\u0627"},...{}}' :style='""' class="my-3 container" >
                <template #default>   </template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
